"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";
import AuthCard from "@/app/components/app/AuthCard";
import { ErrorMessage, Field, PrimaryButton } from "@/app/components/app/ui";
import { register } from "@/lib/auth";

export default function RegisterPage() {
  const router = useRouter();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError(null);
    setLoading(true);

    const data = new FormData(event.currentTarget);

    try {
      await register(String(data.get("email") ?? ""), String(data.get("password") ?? ""));
      router.push("/onboarding");
    } catch (err) {
      setError(err instanceof Error ? err.message : "No se pudo crear la cuenta");
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthCard
      footer={{ text: "¿Ya tienes cuenta?", label: "Inicia sesión", href: "/login" }}
      subtitle="Crea tu cuenta y completa los datos fiscales para empezar con Vilatio."
      title="Crea tu cuenta"
    >
      <form className="app-form" onSubmit={handleSubmit}>
        <ErrorMessage message={error} />
        <Field label="Email" name="email" required type="email" />
        <Field label="Contraseña" name="password" required type="password" />
        <PrimaryButton disabled={loading}>{loading ? "Creando..." : "Crear cuenta"}</PrimaryButton>
      </form>
    </AuthCard>
  );
}
